import { kebabCase } from 'lodash';
import { pascalCase } from 'utils/pascal-case';
import { unreachable } from 'utils/unreachable';
import { TermSeparator } from './separators';
export var EstimateFieldFilterOperationType = /*#__PURE__*/ function(EstimateFieldFilterOperationType) {
    EstimateFieldFilterOperationType["IsMoreThan"] = "IsMoreThan";
    EstimateFieldFilterOperationType["IsLessThan"] = "IsLessThan";
    return EstimateFieldFilterOperationType;
}({});
export var EstimateRelativeDirection = /*#__PURE__*/ function(EstimateRelativeDirection) {
    EstimateRelativeDirection["Late"] = "Late";
    EstimateRelativeDirection["Early"] = "Early";
    return EstimateRelativeDirection;
}({});
const isValid = (filter)=>{
    switch(filter.type){
        case "IsMoreThan":
        case "IsLessThan":
            return filter.days != null;
        default:
            return true;
    }
};
const toString = (filter)=>{
    const type = kebabCase(filter.type);
    switch(filter.type){
        case "IsMoreThan":
        case "IsLessThan":
            return [
                type,
                `${JSON.stringify(filter.days)}~${kebabCase(filter.direction)}`
            ].join(TermSeparator);
        default:
            return unreachable(filter);
    }
};
const parse = (value, field)=>{
    const [type_string, meta] = value.split(TermSeparator);
    const type = pascalCase(type_string);
    switch(type){
        case "IsMoreThan":
        case "IsLessThan":
            {
                const [days, direction] = meta.split('~');
                return {
                    field,
                    type,
                    days: JSON.parse(days),
                    direction: pascalCase(direction)
                };
            }
        default:
            return unreachable(type);
    }
};
export const EstimateFieldFilter = {
    isValid,
    toString,
    parse
};
